import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles/apricot.css';
import App from './App.jsx';

document.body.classList.add('apricot');
createRoot(document.getElementById('root')).render(<App />);
